import script from "./BaseSidePanelSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSidePanelSection.vue?vue&type=script&setup=true&lang=ts"

import "./BaseSidePanelSection.vue?vue&type=style&index=0&id=74675641&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74675641"]])

export default __exports__